import { Modal } from 'antd';
import { Button } from './Button';
import './confirmationModal.css';

const ConfirmationModal = ({ open, onCancel, onDecline = onCancel, onConfirm, title, children }) => (
  <Modal open={open} onCancel={onCancel} title={title} footer={null} width={440} centered className='dashboard-confirmation-modal' destroyOnHidden>
    <div className='dashboard-confirmation-modal__message'>{children}</div>
    <div className='dashboard-confirmation-modal__actions'>
      <Button variant='secondary' htmlType='button' onClick={onDecline}>No</Button>
      <Button variant='primary' htmlType='button' onClick={onConfirm}>Yes</Button>
    </div>
  </Modal>
);

export default ConfirmationModal;
